import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import StrokeMarquee from "@/components/site/StrokeMarquee";
import Manifesto from "@/components/site/Manifesto";
import Sound from "@/components/site/Sound";
import Transmission from "@/components/site/Transmission";

export default function ZiEnzi() {
  return (
    <main className="relative bg-ink min-h-screen selection:bg-acid selection:text-ink" data-testid="zienzi-page">
      <Nav />
      <Hero />
      <StrokeMarquee />
      <Manifesto />
      <Sound />
      <Transmission />
    </main>
  );
}
